export default {
  type: null,
  data: null,
  visible: false,
};
